import { FaqSection } from '~/graphql/generated/graphql';

export const FAQ_SECTION_LABEL_KEYS = {
  [FaqSection.General]: 'unified.faq.sections.general',
  [FaqSection.Referral]: 'unified.faq.sections.referral',
  [FaqSection.Cashout]: 'unified.faq.sections.cashout',
  [FaqSection.Westpac_50_100]: 'unified.faq.sections.westpac50100',
  [FaqSection.SchoolsLanding]: 'unified.faq.sections.schoolsLanding',
  [FaqSection.SchoolsLeadersLanding]: 'unified.faq.sections.schoolsLeadersLanding',
  [FaqSection.SchoolsAdvisorsLanding]: 'unified.faq.sections.schoolsAdvisorsLanding',
  [FaqSection.Campaign]: 'unified.faq.sections.campaign',
} as const satisfies Record<FaqSection, string>;

/** Where each section's FAQs appear, shown under the section picker in the FAQ editor. */
export const FAQ_SECTION_SURFACE_KEYS = {
  [FaqSection.General]: 'unified.faq.surfaces.general',
  [FaqSection.Referral]: 'unified.faq.surfaces.referral',
  [FaqSection.Cashout]: 'unified.faq.surfaces.cashout',
  [FaqSection.Westpac_50_100]: 'unified.faq.surfaces.westpac50100',
  [FaqSection.SchoolsLanding]: 'unified.faq.surfaces.schoolsLanding',
  [FaqSection.SchoolsLeadersLanding]: 'unified.faq.surfaces.schoolsLeadersLanding',
  [FaqSection.SchoolsAdvisorsLanding]: 'unified.faq.surfaces.schoolsAdvisorsLanding',
  [FaqSection.Campaign]: 'unified.faq.surfaces.campaign',
} as const satisfies Record<FaqSection, string>;

/** The segment the General section had before the rename. The retired-routes middleware redirects it, so the page's validate lets it through. */
export const RETIRED_FAQ_SECTION_SEGMENT = 'default';

/** The URL segment for a section: `/faq/<segment>`. Enum values are the uppercase GraphQL names. */
export const faqSectionRouteSegment = (section: FaqSection): string => section.toLowerCase();

/** The section a `/faq/<segment>` param names, or undefined when it is not a lowercase section value or is Campaign, which has no public FAQs. */
export const faqSectionFromRouteParam = (param: unknown): FaqSection | undefined => {
  if (typeof param !== 'string' || param !== param.toLowerCase()) {
    return undefined;
  }
  const upper = param.toUpperCase();
  if (upper === FaqSection.Campaign) {
    return undefined;
  }
  return (Object.values(FaqSection) as string[]).includes(upper) ? (upper as FaqSection) : undefined;
};
